const relatedArticles = [
  {
    title: "Calculate Pregnancy Due Date – Know Baby’s Arrival Date",
    url: "https://parenting.firstcry.com/articles/calculate-pregnancy-due-date-know-babys-arrival-date/",
    image: "https://cdn.cdnparenting.com/articles/2017/10/06172907/How-to-Calculate-Due-Date-768x525.avif",
    id: "970"
  },
  {
    title: "21 Early Pregnancy Symptoms Before Missed Period",
    url: "https://parenting.firstcry.com/articles/21-early-pregnancy-symptoms-before-missed-period/",
    image: "https://cdn.cdnparenting.com/articles/2019/06/28155412/Early-Pregnancy-Symptoms-before-Missed-Period.avif",
    id: "106424"
  },
  {
    title: "12 Uncommon Signs of Pregnancy",
    url: "https://parenting.firstcry.com/articles/10-uncommon-signs-of-pregnancy/",
    image: "https://cdn.cdnparenting.com/articles/2018/06/345505142-H-768x525.avif",
    id: "135478"
  },
  {
    title: "First Month of Pregnancy – Symptoms, Precautions and Care Tips",
    url: "https://parenting.firstcry.com/articles/first-month-of-pregnancy-symptoms-precautions-and-care-tips/",
    image: "https://cdn.cdnparenting.com/articles/2018/03/661336126-H-768x525.avif",
    id: "110383"
  },
  {
    title: "First Trimester of Pregnancy – Your Ultimate Guide",
    url: "https://parenting.firstcry.com/articles/first-trimester-of-pregnancy-your-ultimate-guide/",
    image: "https://cdn.cdnparenting.com/articles/2018/06/604597520-h-768x525.avif",
    id: "129111"
  },
  {
    title: "How to Know Pregnancy Without Doing a Test",
    url: "https://parenting.firstcry.com/articles/how-to-know-pregnancy-without-doing-a-test/",
    image: "https://cdn.cdnparenting.com/articles/2018/06/651308647-H-768x525.avif",
    id: "129489"
  },
  {
    title: "List of Pregnancy Symptoms You Shouldn’t Ignore",
    url: "https://parenting.firstcry.com/articles/list-of-pregnancy-symptoms-you-shouldnt-ignore/",
    image: "https://cdn.cdnparenting.com/articles/2018/09/431039668-H-768x525.avif",
    id: "156178"
  }
];
export default relatedArticles;
